import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  label?: string;
}


import { ref } from 'vue';

import Icon from '@components/Icon.vue';

import { faPlus } from '@icons/regular/faPlus';
import { faMinus } from '@icons/regular/faMinus';

declare module 'vue/types/vue' {
  export interface Vue {
    CardExpandable: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardExpandable' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: null
  },
  setup(__props: any) {

/**
 * `CardExpandable` component properties.
 */


const expanded = ref(false);

return { __sfc: true,expanded, Icon, faPlus, faMinus }
}

})